export const RCB = "real-cookie-banner";
export * from "./gdprCompliant";